export default __webpack_public_path__ + "static/media/1901.f15f4fd2.png";